export default __webpack_public_path__ + "static/media/social-icon-1.bb13c961.svg";